import { FuseUtils } from '@fuse/utils';

export class Request {
    id: number;
    type: string;
    comment: string;

    /**
     * Constructor
     *
     * @param request
     */
    constructor(request) {
        {
            this.id = request.id || FuseUtils.generateGUID();
            this.type = request.type || '';
            this.comment = request.comment || '';
        }
    }
}
